module.exports = __webpack_public_path__ + "img/ep-cristal.1d331ac9.jpg";